// extracted by mini-css-extract-plugin
module.exports = {"container":"news-content-with-illustration_container__l0RqK","image":"news-content-with-illustration_image__pTZs0","reverse":"news-content-with-illustration_reverse__ZgDqH"};